import { render, staticRenderFns } from "./account.vue?vue&type=template&id=01e01579"
import script from "./account.vue?vue&type=script&lang=ts"
export * from "./account.vue?vue&type=script&lang=ts"
import style0 from "./account.vue?vue&type=style&index=0&id=01e01579&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports